import { UsersIcon } from "lucide-react";
import DashboardIcon from "../icons/dashboard/components/DashboardIcon";
import TotalCourse from "../icons/dashboard/components/TotalCourse";
import TotalGroups from "../icons/dashboard/components/TotalGroups";
import TotalCurriculum from "../icons/dashboard/components/TotalCurriculum";
import TotalEnrollments from "../icons/dashboard/components/TotalEnrollments";
import QuizReport from "../icons/dashboard/components/QuizReport";

export const STATUS_MAP = {
  COMPLETED: 'Completed',
  IN_PROGRESS: 'In Progress',
  PENDING: 'Pending',
  'Not Started': 'Not Started',
  'In Progress': 'In Progress',
  'Completed': 'Completed'
};

export const STATUS_OPTIONS = [
  { label: "Completed", value: "Completed" },
  { label: "In Progress", value: "In Progress" },
  { label: "Not Started", value: "Not Started" },
];

export const SUB_TYPE_OPTIONS = [
  { label: "All", value: "ALL" },
  { label: "Users", value: "USER" },
  { label: "Groups", value: "GROUP" },
];

export const ADHERENCE_ORDER = [
  'Overdue',
  'Not Due Yet',
  'Behind Schedule',
  'On Track',
  'Late',
  'On Time'
];


export const sidebarItems = [
  {
    id: "dashboard",
    label: "Dashboard",
    link: "/user",
    staticIcon: <DashboardIcon />,
    activeIcon: <DashboardIcon color="#910E11" />,
  },
  {
    id: "courses",
    label: "Courses",
    link: "/my-courses",
    staticIcon: <TotalCourse />,
    activeIcon: <TotalCourse color="#910E11" />,
  },
  {
    id: "groups",
    label: "Groups",
    link: "/my-groups",
    staticIcon: <TotalGroups />,
    activeIcon: <TotalGroups color="#910E11" />,
  },
];

export const adminSidebarItems = [
      {
        id: "dashboard",
        label: "Dashboard",
        link: "/admin",
        staticIcon: <DashboardIcon />,
        activeIcon: <DashboardIcon color="#910E11" />,
      },
      {
        id: "users",
        label: "Users",
        link: "/users",
        staticIcon: <UsersIcon color="#787878" />,
        activeIcon: <UsersIcon color="#910E11" />,
      },
      {
        id: "groups",
        label: "Groups",
        link: "/group",
        staticIcon: <TotalGroups />,
        activeIcon: <TotalGroups color="#910E11" />,
      },
      {
        id: "courses",
        label: "Courses",
        link: "/books",
        staticIcon: <TotalCourse />,
        activeIcon: <TotalCourse color="#910E11" />,
      },
      {
        id: "curriculums",
        label: "Curriculums",
        link: "/bundles",
        staticIcon: <TotalCurriculum />,
        activeIcon: <TotalCurriculum color="#910E11" />,
      },
      {
        id: "enrollments",
        label: "Enrollments",
        link: "/enroll",
        staticIcon: <TotalEnrollments />,
        activeIcon: <TotalEnrollments color="#910E11" />,
      },
      {
        id: "quiz-report",
        label: "Quiz Report",
        link: "/quiz-report",
        staticIcon: <QuizReport />,
        activeIcon: <QuizReport color="#910E11" />,
      },
      {
        id: "domain",
        label: "Domain",
        link: "/domain",
        staticIcon: <UsersIcon />,
        activeIcon: <UsersIcon color="#910E11" />,
      },
    ];

    
export const BASE_FIELDS_DOMAIN = [
  {
    name: "domain",
    label: "Domain Name",
    type: "text",
    required: true,
    placeholder: "e.g. google.com",
    section: "Domain Details",
  },
];

export const STATUS_FIELD_DOMAIN = {
  name: "isActive",
  label: "Status",
  type: "select",
  required: true,
  placeholder: "Select status",
  section: "Domain Details",
  options: [
    { id: "true", value: "true", label: "Active" },
    { id: "false", value: "false", label: "Inactive" },
  ],
};


export const COURSE_FILTER_OPTIONS = [
  { value: "all", label: "All Allocations" },
  { value: "BUNDLE", label: "Curriculums" },
  { value: "COURSE", label: "Courses" },
];

export const ENROLLMENT_OPTIONS = [
  { label: "All Enrollments", value: "ALL" },
  { label: "Groups", value: "GROUPS" },
  { label: "Users", value: "USERS" },
]

export const TAB_OPTIONS= [
  { key: "active", label: "Active" },
  { key: "inactive", label: "Inactive" },
]
